export default __webpack_public_path__ + "static/media/emoji_tournaments.e9a65b2e.svg";